const authDataKey = 'warehouse-auth-data';

function loggedIn() {
    const authData = localStorage.getItem(authDataKey);

    if (authData) {
        const data = JSON.parse(authData);

        return data.token !== null;
    }

    return false;
}

function setData(data) {
    localStorage.setItem(authDataKey, JSON.stringify(data));
}

function getUserData() {
    const authData = localStorage.getItem(authDataKey);

    if (authData) {
        const data = JSON.parse(authData);

        return data.user;
    }

    return null;
}

function getToken() {
    const authData = localStorage.getItem(authDataKey);

    if (authData) {
        const data = JSON.parse(authData);

        return data.token;
    }

    return null;
}

function getMenu() {
    const authData = localStorage.getItem(authDataKey);

    if (authData) {
        const data = JSON.parse(authData);

        return {
            type : data.user.user_type,
            menu : data.user.user_menu
        };
    }

    return {};
}

function clearData() {
    localStorage.removeItem(authDataKey);
}

export default {
    loggedIn,
    setData,
    getUserData,
    getToken,
    clearData,
    getMenu,
};